import { mapState } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      default() {
        return {
          id: '',
          type: '',
          options: {},
        }
      },
    },
    itemStyle: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapState('landing', ['currentView']),
    options() {
      return this.item.options
    },
  },
}
